var htmlc1, htmlc2, htmlc3;
var test = "false";
var printWholePage = false;

function GenerateImage() {
    $('#figuresDiv').addClass("print-padding");
    $('#customLegendDiv').addClass("print-padding");
    //$('#plotDetails').addClass("print-padding");
    $('#customLegendDiv').addClass("fs-18");
    $('#plotDetails').addClass("fs-18");
    $('#plotDetails').find(".print-hide").hide();
    $('#plotDetails').find(".print-10").addClass("print-width-10");
    $('#plotDetails').find(".print-20").addClass("print-width-20");
    $('#plotDetails').find(".print-40").addClass("print-width-40");
    $('#plotDetails').find(".table-chart-details").addClass("print-margin");
    //$('#plotDetails').find(".table-chart-details").addClass("pdB-20");
    html2canvas($('#figuresDiv'), {
        onrendered: function (canvas) {
            var src = canvas.toDataURL("image/jpg");
            htmlc3 = {
                img_attribute: src
            };
        }
    });

    html2canvas($('#customLegendDiv'), {
        onrendered: function (canvas) {
            var src = canvas.toDataURL("image/jpg");
            htmlc1 = {
                img_attribute: src
            };
        }
    });

    html2canvas($('#plotDetails'), {
        onrendered: function (canvas) {
            var src = canvas.toDataURL("image/jpg");
            htmlc2 = {
                img_attribute: src
            };
        }
    });
    $('#figuresDiv').removeClass("print-padding");
    $('#customLegendDiv').removeClass("print-padding");
    // $('#plotDetails').removeClass("print-padding");
    $('#customLegendDiv').removeClass("fs-18");
    $('#plotDetails').removeClass("fs-18");
    $('#plotDetails').find(".print-hide").show();
    $('#plotDetails').find(".print-10").removeClass("print-width-10");
    $('#plotDetails').find(".print-20").removeClass("print-width-20");
    $('#plotDetails').find(".print-40").removeClass("print-width-40");
    $('#plotDetails').find(".table-chart-details").removeClass("print-margin");
    //$('#plotDetails').find(".table-chart-details").removeClass("pdB-20");
}
$(".swipe-wrap").on('click', ".toggle-panel-body", function () {
    $(this).find("i").toggleClass("fa-angle-down fa-angle-up");
    if ($(this).find("i").hasClass("fa-angle-up")) {
        $(this).find("i").attr("title", "Collapse");
    } else {
        $(this).find("i").attr("title", "Expand");
    }
});

$(".swipe-wrap").on('click', ".toggle-row-element", function (e) {
    e.preventDefault();
    //$(this).toggleClass("fa-chevron-down fa-chevron-up");
    if ($(this).attr("title") == "Expand") {
        $(this).attr("title", "Collapse");
    } else {
        $(this).attr("title", "Expand");
    }
    $(this).toggleClass("fa-angle-up fa-angle-down");
    $(this).closest("tr").next().fadeToggle('slow');
    //if ($(".toggle-row-element").not(".hide").hasClass("fa-angle-down")) {
    //    $(".toggle-all-row-element").removeClass("fa-angle-double-up").addClass("fa-angle-double-down");
    //} else {
    //    $(".toggle-all-row-element").addClass("fa-angle-double-up").removeClass("fa-angle-double-down");
    //}
    if ($("#searchResultsTable").find(".fa-angle-up").length <= 0) {
        $(".toggle-all-row-element").removeClass("fa-angle-double-up").addClass("fa-angle-double-down");
        $(".fa-angle-double-down").attr("title", "Expand all");
    }
    else {
        if ($("#searchResultsTable").find(".fa-angle-down").length == 0) {
            $(".toggle-all-row-element").addClass("fa-angle-double-up").removeClass("fa-angle-double-down");
            $(".fa-angle-double-up").attr("title", "Collapse all");
        }
    }

    if ($("#viewMyDataSearchResultsTable").find(".fa-angle-up").length <= 0) {
        $(".toggle-all-row-element").removeClass("fa-angle-double-up").addClass("fa-angle-double-down");
        $(".fa-angle-double-down").attr("title", "Expand all");
    }
    else {
        if ($("#viewMyDataSearchResultsTable").find(".fa-angle-down").length == 0) {
            $(".toggle-all-row-element").addClass("fa-angle-double-up").removeClass("fa-angle-double-down");
            $(".fa-angle-double-up").attr("title", "Collapse all");
        }
    }

    if ($("#viewTeamDataSearchResultsTable").find(".fa-angle-up").length <= 0) {
        $(".toggle-all-row-element").removeClass("fa-angle-double-up").addClass("fa-angle-double-down");
        $(".fa-angle-double-down").attr("title", "Expand all");
    }
    else {
        if ($("#viewTeamDataSearchResultsTable").find(".fa-angle-down").length == 0) {
            $(".toggle-all-row-element").addClass("fa-angle-double-up").removeClass("fa-angle-double-down");
            $(".fa-angle-double-up").attr("title", "Collapse all");
        }
    }
});

//Toggle all row elementenableSearchBtn();
$(".swipe-wrap").on('click', ".toggle-all-row-element", function (e) {
    e.preventDefault();
    //$(this).toggleClass("fa-chevron-down fa-chevron-up");
    if ($(this).find("i").hasClass("fa-angle-double-down")) {
        //$(".toggle-row-element").fadeIn("slow");
        //$(".toggle-row-element").removeClass("fa-angle-down").addClass("fa-angle-up");
        //$(".toggle-row-element").attr("title", "Collapse");
        $(this).attr("title", "Hide Peak Assignments");
        $(this).find(".toggle-row-text").text("Hide Peak Assignment Details ");
        $(".fa-angle-double-down").attr("title", "Hide Peak Assignments");
        $(this).find("i").addClass("fa-angle-double-up").removeClass("fa-angle-double-down");
        $(".collapsable-table-tr").fadeIn('slow');
    } else {
        //$(".toggle-row-element").fadeOut("slow");
        $(this).attr("title", "View Peak Assignments");
        $(this).find(".toggle-row-text").text("Show Peak Assignment Details ");
        $(".fa-angle-double-up").attr("title", "View Peak Assignments");
        $(this).find("i").removeClass("fa-angle-double-up").addClass("fa-angle-double-down");
        $(".collapsable-table-tr").fadeOut('slow');
    }
});

$("body").on('click', ".add-chemical", function (e) {
    var $this = $(this);
    if ($('.workspace-select').text().toLowerCase() == "choose workspace" || ($this.hasClass("proceed-btn")) || $('#enable-add-chemical').text().toLowerCase() == "1" || ($this.hasClass("remove-chemical"))) { //fa-add-chemical
        $this = ($this.hasClass("proceed-btn")) ? $(".fa-add-chemical") : $this;
        if (!($this.hasClass("remove-chemical"))) {
            var chemProp = [];
            var createString = "";
            //enable plot btn
            $(".plot-chart").removeClass("disabled");
            $(".plot-chart").prop("disabled", false);
            $(".plotting-area").parent().removeClass("disabled");
            $(".plotting-area").removeClass("disabled").attr("disabled", false);
            $(".clear-all-datasets").show();
            $(".no-chemical-msg").hide();
            $(".added-chemicals-title").removeClass("title-border-bottom");
            //assign id equivalent to row which will be added in table
            $this.attr("id", count);
            count += 1;
            var getParentID = $this.attr("parent-id");

            $("." + getParentID).find("[parent-id='" + getParentID + "']").toggleClass("fa-plus fa-minus");
            $("." + getParentID).find("[parent-id='" + getParentID + "']").addClass("remove-chemical");
            $("." + getParentID).find("[parent-id='" + getParentID + "']").addClass("color-red");
            $("." + getParentID).find("[parent-id='" + getParentID + "']").attr("title", "Remove");

            var getParentId = $this.closest("tr.parent-row").attr("id");
            if (getParentId) {
                $("." + getParentId).addClass("added-row");
                $("." + getParentId).next().addClass("added-row");
                $("." + getParentId).find(".xs-tbody").addClass("added-row");
                $("." + getParentId + " td.hidden-xs").each(function () {
                    if (!($this.children().hasClass("fa-minus") || $this.children().hasClass("toggle-row-element"))) {
                        chemProp.push($this.text());
                    }
                });
            }
            if ($(".xs-tbody").hasClass("added-row") && !($(".plot-chart.visible-xs").visible(true))) {
                $(".plot-chart-xs").fadeIn();
            } else {
                $(".plot-chart-xs").hide();
            }


        } else {
            var getParentId = $this.closest("tr.parent-row").attr("id");
            $("." + getParentId).removeClass("added-row");
            $("." + getParentId).next().removeClass("added-row");
            $("." + getParentId).find(".xs-tbody").removeClass("added-row");
            if ($(".xs-tbody").hasClass("added-row") && !($(".plot-chart.visible-xs").visible(true))) {
                $(".plot-chart-xs").fadeIn();
            } else {
                $(".plot-chart-xs").hide();
            }

            var getParentID = $this.attr("parent-id");
            $("." + getParentID).find("[parent-id='" + getParentID + "']").toggleClass("fa-plus fa-minus");
            $("." + getParentID).find("[parent-id='" + getParentID + "']").removeClass("remove-chemical");
            $("." + getParentID).find("[parent-id='" + getParentID + "']").removeClass("color-red");
            $("." + getParentID).find("[parent-id='" + getParentID + "']").attr("title", "Add");
            $("#addedChemicals").find("#addedChemicalProp-" + getParentId).fadeOut('fast', function () {
                $("#addedChemicals").find("#addedChemicalProp-" + getParentId).remove();
            });
            //if the last chemical is removed
            if ($("#addedChemicals tbody").children().length == 1) {
                $(".plot-chart").addClass("disabled");
                $(".plot-chart").prop("disabled", true);
                $(".pull-right.clear-all-datasets").hide();
                $(".no-chemical-msg").fadeIn();
                $(".added-chemicals-title").addClass("title-border-bottom");
                $(".plotting-area").parent().removeClass("active").addClass("disabled");
                $(".plotting-area").addClass("disabled").attr("disabled", true);
            }
        }
    }
});
//remove chemical when click on remove icon
$(".swipe-wrap").on('click', ".remove-dataset", function () {

    var getParentId = $(this).closest("tr").attr("id");
    var idArray = getParentId.split("-");
    if ($("#searchResultsTable").find("#" + idArray[1]).find(".remove-chemical").length > 0) {
        $("#searchResultsTable").find("#" + idArray[1]).find(".remove-chemical.md-view").trigger("click");
    } else if ($("#viewMyDataSearchResultsTable").find("#" + idArray[1]).find(".remove-chemical").length > 0) {
        $("#viewMyDataSearchResultsTable").find("#" + idArray[1]).find(".remove-chemical.md-view").trigger("click");
    } else if ($("#viewTeamDataSearchResultsTable").find("#" + idArray[1]).find(".remove-chemical").length > 0) {
        $("#viewTeamDataSearchResultsTable").find("#" + idArray[1]).find(".remove-chemical.md-view").trigger("click");
    }
    else {

        var Id = $(this).attr('data-Id');
        //var fId = $(this).attr('data-fId');
        var tech = $(this).attr('data-tech');

        //$(".remove-dataset").scope().RemoveSelectedDataSet(parseInt(Id), tech);

        if ($(window).width() > 767) {
            var getParentId = $(this).closest("tr").attr("id");
        } else {
            //var getParentId = $(this).closest("table").parents("tr").attr("id");
            var getParentId = $(this).closest("tr").attr("id");
        }

        $("#addedChemicals").find("#" + getParentId).fadeOut('fast', function () {
            $("#addedChemicals").find("#" + getParentId).remove();
        });

        //if the last chemical is removed
        if ($("#addedChemicals tbody").children().length == 1) {
            $(".plot-chart").addClass("disabled");
            $(".plot-chart").prop("disabled", true);
            //$(".clear-all-datasets").addClass("disabled");
            //$(".clear-all-datasets").prop("disabled", true);
            $(".pull-right.clear-all-datasets").hide();
            $(".no-chemical-msg").fadeIn();
            $(".added-chemicals-title").addClass("title-border-bottom");
            $(".plotting-area").parent().removeClass("active").addClass("disabled");
            $(".plotting-area").addClass("disabled").attr("disabled", true);
        }

    }
});

//Validation code
$(".swipe-wrap").on('click', '.custom-dropdown li', function () {
    if ($(this).hasClass("disabled")) {
        return false;
    }
    var getYear = $(this).text();
    $(this).parent().siblings("input[type=text]").val(getYear);
    $(this).parent().siblings("label").addClass("active");
    $(this).parent().siblings(".from-to-year").removeClass("border-red");
    $(this).parent().siblings("label").find(".error-msg").hide();
    toggleSearchBtn();
});
$(".swipe-wrap").on('click', '.from-dropdown li', function () {
    ///enabled To date
    $("#fromDate").siblings("label").find("span").hide();
    $("#fromDate").removeClass("border-red");
    toggleSearchBtn()
    $("#toDate").removeClass("disabled");
    $("#toDate").prop("disabled", false);
    var getYearAttr = $(this).attr("year");
    //$(".to-dropdown li").removeClass("disabled");
    $(".to-dropdown li").show();
    $(".to-dropdown li").removeClass("to-show");
    $(".to-dropdown li").each(function () {
        $(this).addClass("to-show");
        if (getYearAttr == $(this).attr("year")) {
            //$(this).hide();
            return false;
        }
    });
    $(".to-dropdown li").not(".to-show").hide();
    if ($("#toDate").val().trim() == "") {
        $("#toDate").focus();
        setTimeout(function () {
            $("#toDate").parent().addClass("open");
        }, 100)
    } else {
        var getVal = $("#toDate").val();
        if (getVal < $("#fromDate").val()) {
            $("#toDate").addClass("border-red");
            $("#toDate").focus();
            $(".end-year-greater-error-msg").show();
            toggleSearchBtn()
        }
        else {
            $("#toDate").removeClass("border-red");
            $(".end-year-greater-error-msg").hide();
            toggleSearchBtn();
        }

    }

});
//to dropdown on click
$(".swipe-wrap").on('click', '.to-dropdown li', function (e) {

    var getVal = $("#toDate").val();
    if (getVal < $("#fromDate").val()) {
        $("#toDate").addClass("border-red");
        $("#toDate").focus();
        toggleSearchBtn()
        $(".end-year-greater-error-msg").fadeIn();
    }
    else {
        $("#toDate").removeClass("border-red");
        $(".end-year-greater-error-msg").hide();
        toggleSearchBtn();
    }
});

//Round and ceil start and end values and validate start and end values
$(".swipe-wrap").on("focusout", "#enegryStartVal", function () {
    if ($(this).val() != "") {
        if (!(isNaN($(this).val()))) {
            $(this).val(Math.floor($(this).val()));
            $("#enegryEndVal").removeAttr("disabled");
        } else {
            $(this).siblings("span").find("span").fadeIn();
            $(this).addClass("border-red");
            $("#enegryEndVal").attr("disabled", "disabled");
        }
    } else {
        $("#enegryEndVal").attr("disabled", "disabled");
        $("#enegryEndVal").val("");
        $("#enegryEndVal").siblings("span").removeClass("active");
        $("#enegryEndVal").parent().siblings("label").removeClass("active");
        $("#enegryEndVal").siblings("label").removeClass("active");
    }
    if ($("#enegryEndVal").val() != "") {
        compareEnergy();
    }
});

function compareEnergy() {
    var startVal = $("#enegryStartVal").val();//Defect 476 
    if (startVal == "") {
        startVal = 0;
    } else if (isNaN(startVal)) {
        return false;
    } else if (isNaN($("#enegryEndVal").val())) {
        return false;
    }
    if (parseInt(startVal) < parseInt($("#enegryEndVal").val())) {
        $("#enegryEndVal").siblings("span").find("span").hide();
        $("#enegryEndVal").removeClass("border-red");
        toggleSearchBtn();
    } else {
        $("#enegryEndVal").siblings("span").find("span").fadeIn();
        $("#enegryEndVal").addClass("border-red");
        toggleSearchBtn();
    }
}

$(".swipe-wrap").on("keyup", "#enegryStartVal", function () {
    if ($(this).val() != "") {
        if (!(isNaN($(this).val()))) {
            $("#enegryEndVal").removeAttr("disabled");
            $(this).siblings("span").find("span").fadeOut();
            $(this).removeClass("border-red");
        } else {
            $(this).siblings("span").find("span").fadeIn();
            $(this).addClass("border-red");
            $("#enegryEndVal").attr("disabled", "disabled");
        }
    } else {
        $("#enegryEndVal").attr("disabled", "disabled");
        $(this).siblings("span").find("span").fadeOut();
        $(this).removeClass("border-red");
    }
    if ($("#enegryEndVal").val() != "") {
        compareEnergy();
    }
});
$(".swipe-wrap").on("focusout", "#enegryEndVal", function () {
    if ($(this).val() != "") {
        if (!(isNaN($(this).val()))) {
            $(this).val(Math.ceil($(this).val()));

        } else {
            $(this).siblings("span").find("span").fadeIn();
            $(this).addClass("border-red");
            toggleSearchBtn();
        }

        compareEnergy();
    }
});

$(".swipe-wrap").on("keyup", "#enegryEndVal", function () {
    if ($(this).val() != "") {
        if (!(isNaN($(this).val()))) {
            $(this).val(Math.ceil($(this).val()));

        } else {
            $(this).siblings("span").find("span").fadeIn();
            $(this).addClass("border-red");
            toggleSearchBtn();
        }

        compareEnergy();
    } else {
        //var startVal = $("#enegryStartVal").val();
        //if (startVal == "") {
        $("#enegryEndVal").siblings("span").find("span").hide();
        $("#enegryEndVal").removeClass("border-red");
        toggleSearchBtn();
        //}
    }
});

//add class when clicked on dropdown
$(".swipe-wrap").on('click', '.year-dropdown li', function () {
    $(".year-dropdown li>a").removeClass("clicked");
    $(this).find("a").addClass("clicked");
});
//Valida tion on start and end year
$(".swipe-wrap").on("focusout", "#fromDate", function (e) {
    //If user has clicked on dropdown so skip validation
    if ($(this).val() == "" && $(this).parent().hasClass("open")) {
        $(this).siblings("label").find("span").hide();
        $(this).removeClass("border-red");
        toggleSearchBtn()
        return false;
    }
    //if ($(this).val() == "" && "#" + e.target.id != "#fromDate") {
    //    $(this).siblings("label").find("span").hide();
    //    $(this).removeClass("border-red");
    //    toggleSearchBtn()
    //    return false;
    //}
    var getCurrentYear = new Date().getFullYear();
    var getVal = $(this).val();
    var getYearAttr;
    $(".start-year-error-msg").hide();
    $(".start-year-exceed-error-msg").hide();
    $("#fromDate").removeClass("border-red");
    toggleSearchBtn();
    //When toDate valus exist without from date
    if ($(this).val() == "" && $("#toDate").val() != "") {
        clearToDate();
        return false;
    }
    if (isNaN(getVal)) {
        $(".start-year-error-msg").fadeIn();
        $("#fromDate").addClass("border-red");

        toggleSearchBtn()
    } else {
        if (!(parseInt(getVal) <= parseInt(getCurrentYear)) || parseInt(getVal) < 1900) {
            if (getVal != "") {
                $(".start-year-error-msg").fadeIn();
                $("#fromDate").addClass("border-red");
                toggleSearchBtn()
                $(".to-dropdown").parent().removeClass("open");
            }
        }
        else {
            $("#toDate").removeClass("disabled");
            $("#toDate").prop("disabled", false);
            toggleSearchBtn()
            $(".from-dropdown li").each(function () {
                if (getVal == $(this).text()) {
                    getYearAttr = $(this).attr("year");
                }
            });
            //Hide to-dropdown year accordingly
            $(".to-dropdown li").show();
            $(".to-dropdown li").removeClass("to-show");
            $(".to-dropdown li").each(function () {
                $(this).addClass("to-show");
                if (getYearAttr == $(this).attr("year")) {
                    //$(this).hide();
                    return false;
                }
            });
            $(".to-dropdown li").not(".to-show").hide();
        }
    }
});
function clearToDate() {
    $("#toDate").val("");
    $("#toDate").siblings("label").removeClass("active");
    $("#toDate").siblings("label").find("span").hide();
    $("#toDate").removeClass("border-red");
    $("#toDate").addClass("disabled");
    $("#toDate").prop("disabled", true);
    toggleSearchBtn()
}
$(".swipe-wrap").on('keyup', "#fromDate", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 9) {
        //console.log("Tab key poressed")
        $("#fromDate").parent().addClass("open");
    }
    if ($(this).val().trim() != "") {
        if (isNaN(parseInt($(this).val()))) {
            $(".start-year-error-msg").fadeIn();
            $(this).addClass("border-red");
            $(this).focus();
            toggleSearchBtn()
            return false;
        } else {
            $(".start-year-error-msg").hide();
            $(this).removeClass("border-red");
            toggleSearchBtn()
        }
    } else {
        clearToDate();
        $(".start-year-error-msg").hide();
        $(this).removeClass("border-red");
        toggleSearchBtn()
    }
})

//to date dont show when there is error in from date
function chkFromIsDisabled() {
    if ($("#fromDate").hasClass("border-red")) {
        $(this).parent().removeClass("open");
        $(this).addClass("disabled");
        $(this).prop("disabled", true);
        $("#fromDate").focus();
        toggleSearchBtn()
    }
}
$(".swipe-wrap").on('focusin', "#toDate", function () {
    chkFromIsDisabled();
});
//chk whether entered value in to date field is number
$(".swipe-wrap").on('keyup', "#toDate", function (e) {
    chkFromIsDisabled();
    var keyCode = e.keyCode || e.which;
    if (keyCode == 9) {
        //console.log("Tab key poressed")
        $("#toDate").parent().addClass("open");
    }
    // Verify enter Key
    if (keyCode == 13) {
        if ($("#fromDate").hasClass("border-red")) {
            $("#fromDate").focus();
            return false;
        }
        if ($("#toDate").hasClass("border-red")) {
            $("#toDate").focus();
            return false;
        }
    }
    if (isNaN($(this).val())) {
        $(".end-year-greater-error-msg").show();
        $(this).addClass("border-red");
        $(this).focus();
        toggleSearchBtn()
        return false;
    } else {
        $(".end-year-greater-error-msg").hide();
        $(this).removeClass("border-red");
        toggleSearchBtn()
    }
})
$(".swipe-wrap").on('focusout', "#toDate", function (e) {
    //if (e.target == ".to-dropdown li") {
    //    return false;
    //}
    var getVal = $(this).val();
    if (isNaN(getVal)) {
        $(this).addClass("border-red");
        $(".end-year-greater-error-msg").show();
        toggleSearchBtn();
        return false;
    }
    if (getVal != "" && getVal < $("#fromDate").val()) {
        $(this).addClass("border-red");
        $(".end-year-greater-error-msg").show();
        toggleSearchBtn();
    }
    else {
        $(this).removeClass("border-red");
        $(".end-year-greater-error-msg").hide();
        toggleSearchBtn();
    }
});
$(".swipe-wrap").on('click', "#toDate", function () {
    chkFromIsDisabled();
});

//To check whether entered start and end value is number
$(".swipe-wrap").on('keyup', ".number-validate", function () {
    if (isNaN($(this).val())) {
        $(this).siblings("label").find("span").fadeIn();
        $(this).addClass("border-red");
        $(this).focus();
        toggleSearchBtn();
        return false;
    } else {
        $(this).siblings("label").find("span").hide();
        $(this).removeClass("border-red");
        toggleSearchBtn();
    }
})

//function Enable search button
function toggleSearchBtn() {
    if ($(".swipe-wrap .search-error-msg").is(":visible")) {
        $(".swipe-wrap").find("#submitButton").addClass("disabled");
        $(".swipe-wrap").find("#submitButton").prop("disabled", true);

        $(".swipe-wrap").find("#advsubmitButton").addClass("disabled");
        $(".swipe-wrap").find("#advsubmitButton").prop("disabled", true);
    } else {
        $(".swipe-wrap").find("#submitButton").removeClass("disabled");
        $(".swipe-wrap").find("#submitButton").prop("disabled", false);

        $(".swipe-wrap").find("#advsubmitButton").removeClass("disabled");
        $(".swipe-wrap").find("#advsubmitButton").prop("disabled", false);

    }
}

function textValidate(name, regExp) {
    var regex = new RegExp(regExp);

    if (regex.test(name)) {
        return true;
    } else {
        return false;
    }
}

$(".swipe-wrap").on('focusout', "#advKeywords", function (e) {
    if ($(this).hasClass("border-red")) {
        //$(this).focus();
        toggleSearchBtn()
    } else {
        toggleSearchBtn()
    }
});
$(".swipe-wrap").on('keyup', "#doi", function (e) {
    var code = e.keyCode || e.which;
    if (code == '9' || $(this).val() == "") {
        $(this).removeClass("border-red");
        $(this).parent().siblings("label").find(".search-error-msg").hide();
        $(this).parent().siblings("label").find(".doi-eg").removeClass("display-none");
        toggleSearchBtn()
        return false;
    }
    var getVal = $(this).val();
    var regExp = "^[0-9\.\/]+$";
    var flag = textValidate(getVal, regExp);
    if (flag == true) {
        $(this).removeClass("border-red");
        $(this).parent().siblings("label").find(".search-error-msg").hide();
        $(this).parent().siblings("label").find(".doi-eg").removeClass("display-none");
        toggleSearchBtn()
    } else {
        $(this).addClass("border-red");
        $(this).focus();
        $(this).parent().siblings("label").find(".search-error-msg").show();
        $(this).parent().siblings("label").find(".doi-eg").addClass("display-none");
        toggleSearchBtn()
    }
});

$(".swipe-wrap").on('focusout', "#doi", function (e) {
    e.preventDefault();
    if ($(this).val() == "") {
        $(this).removeClass("border-red");
        $(this).siblings("label").find(".search-error-msg").hide();
        $(this).siblings("label").find(".doi-eg").removeClass("display-none");
    }
    if ($(this).hasClass("border-red")) {
        toggleSearchBtn()
        return false;
    }
});

function removeValidation(getId) {
    if ($(getId).val() == "") {
        $(getId).removeClass("border-red");
        $(getId).parent().siblings("label").find(".search-error-msg").hide();
    }
    if ($(getId).hasClass("border-red")) {
        toggleSearchBtn()
        return false;
    }
}
$(".swipe-wrap").on('focusout', "#chemicalName", function (e) {
    e.preventDefault();
    removeValidation("#chemicalName");
});
$(".swipe-wrap").on('focusout', "#advKeywords", function (e) {
    e.preventDefault();
    removeValidation("#advKeywords");
});
$(".swipe-wrap").on('focusout', "#hostMaterial", function (e) {
    removeValidation("#hostMaterial")
});
$(".swipe-wrap").on('focusout', "#element", function (e) {
    removeValidation("#element")
});
$(".swipe-wrap").on('focusout', "#transition", function (e) {
    removeValidation("#transition")
});
$(".swipe-wrap").on('focusout', "#authorLName", function (e) {
    var code = e.keyCode || e.which;
    removeValidation("#authorLName");

    if (code == '9') {
        if ($("#authorLName").hasClass("border-red")) {
            $("#authorLName").focus();
            return false;
        }
    }
});

$(".swipe-wrap").on('focusout', "#articleName", function (e) {
    e.preventDefault();
    removeValidation("#articleName");
});

$(".swipe-wrap").on('focusout', "#Region", function () {
    if ($(this).val() == "") {
        $(this).removeClass("border-red");
        $(this).siblings().find("span").hide();
        return false;
    }
    if ($(this).val().toLowerCase() == "survey" || $(this).val().toLowerCase() == "valence band" || $(this).val().toLowerCase() == "transition") {
        $(this).removeClass("border-red");
        $(this).parent().siblings("label").find("span").hide();
    } else {
        $(this).addClass("border-red");
        $(this).parent().siblings("label").find("span").fadeIn();
        $(this).focus();
    }
});
$(".swipe-wrap").on('click', ".technique-checkbox-div .chk-align", function () {
    var techniqueCount = 0;
    $(".technique-checkbox-div .chk-align").each(function () {
        if ($(this).prop("checked") == true) {
            techniqueCount += 1;
        }
    });
    var regionCount = 0;
    $(".region-checkbox-div .chk-align").each(function () {
        if ($(this).prop("checked") == true) {
            regionCount += 1;
        }
    });
    if (techniqueCount != 0) {
        //$(this).closest(".col-lg-12").parent().siblings("label").find("span").hide();
        $('.techique-active-label > .search-error-msg').hide();
        if (regionCount != 0) {
            $(".swipe-wrap").find("#submitButton").removeClass("disabled");
            $(".swipe-wrap").find("#submitButton").prop("disabled", false);

            $(".swipe-wrap").find("#advsubmitButton").removeClass("disabled");
            $(".swipe-wrap").find("#advsubmitButton").prop("disabled", false);
        }
    } else {
        //$(this).closest(".col-lg-12").parent().siblings("label").find("span").fadeIn();
        $('.techique-active-label > .search-error-msg').fadeIn();
        $(".swipe-wrap").find("#submitButton").addClass("disabled");
        $(".swipe-wrap").find("#submitButton").prop("disabled", true);

        $(".swipe-wrap").find("#advsubmitButton").addClass("disabled");
        $(".swipe-wrap").find("#advsubmitButton").prop("disabled", true);
    }
    toggleSearchBtn();
});
//when click on region checkbox
$(".swipe-wrap").on('change', ".region-checkbox-div .chk-align", function () {
    var techniqueCount = 0;
    $(".region-checkbox-div .chk-align").each(function () {
        if ($(this).prop("checked") == true) {
            techniqueCount += 1;
        }
    });
    var regionCount = 0;
    $(".region-checkbox-div .chk-align").each(function () {
        if ($(this).prop("checked") == true) {
            regionCount += 1;
        }
    });
    if (regionCount != 0) {
        $(this).closest(".col-lg-12").parent().siblings("label").find("span").hide();
        if (techniqueCount != 0) {
            $(".swipe-wrap").find("#submitButton").removeClass("disabled");
            $(".swipe-wrap").find("#submitButton").prop("disabled", false);

            $(".swipe-wrap").find("#advsubmitButton").removeClass("disabled");
            $(".swipe-wrap").find("#advsubmitButton").prop("disabled", false);
        }
    } else {
        $(this).closest(".col-lg-12").parent().siblings("label").find("span").fadeIn();
        $(".swipe-wrap").find("#advsubmitButton").addClass("disabled");
        $(".swipe-wrap").find("#advsubmitButton").prop("disabled", true);
    }
    toggleSearchBtn();
});
$(".swipe-wrap").on('keyup', "#accessionId", function (e) {
    var code = e.keyCode || e.which;
    if (code == '9' || $(this).val() == "") {
        $(this).removeClass("border-red");
        $(this).siblings("label").find(".search-error-msg").hide();
        $(this).siblings("label").find(".accession-info").removeClass("display-none");
        toggleSearchBtn()
        return false;
    }
    if (!isNaN($("#accessionId").val())) {
        $(this).removeClass("border-red");
        $(this).siblings("label").find(".search-error-msg").hide();
        $(this).siblings("label").find(".accession-info").removeClass("display-none");
        toggleSearchBtn()
    } else {
        $(this).addClass("border-red");
        $(this).focus();
        $(this).siblings("label").find(".search-error-msg").fadeIn();
        $(this).siblings("label").find(".accession-info").addClass("display-none");
        toggleSearchBtn()
    }
});

$(".swipe-wrap").on('focusout', "#accessionId", function (e) {
    e.preventDefault();
    if ($(this).val() == "") {
        $(this).removeClass("border-red");
        $(this).siblings("label").find(".search-error-msg").hide();
        $(this).siblings("label").find(".accession-info").removeClass("display-none");
    }
    if ($(this).hasClass("border-red")) {
        toggleSearchBtn();
        return false;
    }
});

//clear all datasets
$(".swipe-wrap").on('click', ".clear-all-datasets", function () {
    //$(this).addClass("disabled");
    //$(this).prop("disabled", true);
    if ($(this).attr('class') == "pull-right clear-all-datasets") {
        $(this).hide();
        $(".plot-chart").addClass("disabled");
        $(".plot-chart").prop("disabled", true);
        $("#searchResultsTable").find(".added-row").removeClass("added-row");
        $("#searchResultsTable").find(".add-chemical").removeClass("fa-minus remove-chemical color-red").addClass("fa-plus")
        $("#viewMyDataSearchResultsTable").find(".added-row").removeClass("added-row");
        $("#viewMyDataSearchResultsTable").find(".add-chemical").removeClass("fa-minus remove-chemical color-red").addClass("fa-plus")
        $("#viewTeamDataSearchResultsTable").find(".added-row").removeClass("added-row");
        $("#viewTeamDataSearchResultsTable").find(".add-chemical").removeClass("fa-minus remove-chemical color-red").addClass("fa-plus")
        $("#addedChemicals tbody").children().remove();
        $(".no-chemical-msg").fadeIn();
        $(".plotting-area").parent().removeClass("active").addClass("disabled");
        $(".plotting-area").addClass("disabled").attr("disabled", true);
    }
});
//show hide row hidden elements in mobile view
$(".swipe-wrap").on('click', ".toggle-row-element-icon", function () {
    $(this).parent().hide();
    $(this).parent().parent().find(".hide-row-element-icon").show();
    $(this).parent().parent().find(".row-hidden-element").fadeIn();
});
$(".swipe-wrap").on('click', ".hide-row-element-icon", function () {
    $(this).hide();
    $(this).closest("tbody").siblings().find(".row-hidden-element").hide();
    $(this).parent().closest("table").siblings(".toggle-row-element-div").fadeIn();
});
//DOI
$(".swipe-wrap").on('keyup', "#DOI", function (e) {
    var code = e.keyCode || e.which;
    if (code == '9' || $(this).val() == "") {
        $(this).removeClass("border-red");
        $(this).siblings("label").find(".search-error-msg").hide();
        $(this).siblings("label").find(".doi-eg").removeClass("display-none");
        toggleSearchBtn()
        return false;
    }
    var getVal = $(this).val();
    var regExp = "^[0-9/.]+$";
    var flag = textValidate(getVal, regExp);
    if (flag == true) {
        $(this).removeClass("border-red");
        $(this).siblings("label").find(".search-error-msg").hide();
        $(this).siblings("label").find(".doi-eg").removeClass("display-none");
        toggleSearchBtn()
    } else {
        $(this).addClass("border-red");
        $(this).focus();
        $(this).siblings("label").find(".search-error-msg").fadeIn();
        $(this).siblings("label").find(".doi-eg").addClass("display-none");
        toggleSearchBtn()
    }
});
$(".swipe-wrap").on('focusout', "#DOI", function (e) {
    e.preventDefault();
    if ($(this).val() == "") {
        $(this).removeClass("border-red");
        $(this).siblings("label").find(".search-error-msg").hide();
        $(this).siblings("label").find(".doi-eg").removeClass("display-none");
    }
    if ($(this).hasClass("border-red")) {
        toggleSearchBtn()
        return false;
    }
});
$(".swipe-wrap").on('click', ".amExportButton a", function () {
    var getText = $(this).text();
    if (getText == "Print Graph") {
        showProgressBar();
        printWholePage = false;
    } else if (getText == "Print Page") {
        showProgressBar();
        printWholePage = true;
    }

});
$(document).on("click", function (event) {
    var $trigger = $(".custom-dropdown");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".dropdown-menu").parent().removeClass("open");
    }
});
function togglePlotGraphMobileIcon() {
    var $elem = $(".plot-chart-xs");
    var $window = $(window);
    var $plotBtn = $(".plot-chart.visible-xs");

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    if ((elemBottom < $plotBtn.offset().top) && !($($plotBtn).visible(true))) {
        $(".plot-chart-xs").fadeIn();
    } else {
        $(".plot-chart-xs").hide();
    }
}
$(window).scroll(function () {

    if ($(window).width() < 768 && $(".xs-tbody").hasClass("added-row") && $(".search-nav-link").parent().hasClass("active")) {
        togglePlotGraphMobileIcon();
    }
});

$(".swipe-wrap").on('keyup', "#txtWorkspaceName", function (e) {
    var getVal = $(this).val();
    if (getVal != '') {
        $(this).removeClass("border-red");
        $(this).siblings("label").find("span").hide();
    }
    else {
        $(this).addClass("border-red");
        $(this).focus();
        $("#spanTitleError").html("Invalid workspace name.");
        $(this).siblings("label").find("span").fadeIn();
    }
});

$(".swipe-wrap").on('focusout', "#emailIdToShare", function (e) {
    var getVal = $(this).val();
    if (getVal == '') {
        $(this).removeClass("border-red");
        $(this).siblings("label").find("span").hide();

        //Remove name share validation
        $("#nameShare").removeClass("border-red");
        $("#nameShare").siblings("label").find("span").hide();
    }
});

$(".swipe-wrap").on('focusout', "#txtWorkspaceName", function (e) {
    var getVal = $(this).val();
    if (getVal == '') {
        $(this).removeClass("border-red");
        $(this).siblings("label").find("span").hide();
    }
});

$(".swipe-wrap").on('focusout', "#nameShare", function (e) {
    var getVal = $(this).val();
    if (getVal != '' || getVal == "") {
        $(this).removeClass("border-red");
        $(this).siblings("label").find("span").hide();

        if (getVal == '') {
            $("#emailIdToShare").removeClass("border-red");
            $("#emailIdToShare").siblings("label").find("span").hide();
        }
    }
    //else {
    //    $(this).addClass("border-red");
    //    $(this).siblings("label").find("span").fadeIn();
    //}
});
$(".swipe-wrap").on('keyup', "#nameShare", function (e) {
    var getVal = $(this).val();
    if (getVal != '') {
        $(this).removeClass("border-red");
        $(this).siblings("label").find("span").hide();
    }
});

$('body').on('focus', '#casRegistryNumber, #pubYear, #articleName', function () {
    $(this).prev().addClass('active');

}).on('focusout', '#casRegistryNumber, #pubYear, #articleName', function () {
    if ($(this).val() == '') {
        $(this).prev().removeClass('active');
    }
});

//$('body').on('focus', "#casRegistryNumber", "#pubYear", "#articleName", function (e) {
//    //e.preventDefault();
//    //removeValidation("#casRegistryNumber");
//    $('#casRegistryNumber').prev().addClass('active')
//});

//$(".swipe-wrap").on('focusout', "#casRegistryNumber", "#pubYear", "#articleName", function (e) {
//    //e.preventDefault();
//    //removeValidation("#casRegistryNumber");
//    $('#casRegistryNumber').prev().removeClass('active')
//});


function showProgressBar() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        angular.element(document.getElementsByClassName("page-spinnerIE")).show();
    }
    else {
        angular.element(document.getElementsByClassName("page-spinner")).show();
    }
};

function hideProgressBar() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        angular.element(document.getElementsByClassName("page-spinnerIE")).hide();

    }
    else {

        angular.element(document.getElementsByClassName("page-spinner")).hide();
    }
};
